import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, Dimensions, StyleSheet, Button, BackHandler, Alert, Linking } from 'react-native';
import { WebView } from 'react-native-webview';
import { checkForSessionCookie } from '@/services/typo3api/checkForSessionCookies';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { useLocalSearchParams, useFocusEffect, useRouter, Routes } from 'expo-router';

interface WebViewNavState {
  canGoBack: boolean;
  canGoForward: boolean;
}

export default function HomeScreenComponent() {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(true);
  const [position] = useState(new Animated.Value(0));
 const { webViewURL } = useLocalSearchParams();
  const onBoardingActive = usePersistBoundStore(useCallback((state) => state.onBoardingActive, []));
  const onBoardingState = usePersistBoundStore(useCallback((state) => state.onBoardingState, []));
  const resetOnBoarding = usePersistBoundStore(useCallback((state) => state.resetOnBoarding, []));

  //const webViewRef = useRef<WebView>(null);

  const handleNavigationEvent = async (navState: WebViewNavState) => {
    await checkForSessionCookie(session, login, logout);
    setCanGoBack(navState.canGoBack);
  }

  const baseUrl = 'https://Relaunch2023:Mp9zvcBkxUuabmm9FhdT@staging.boyens-api.de/';
  let fullUrl = '';
  if (webViewURL) {
    fullUrl = `${baseUrl}${webViewURL}`;
  } else {
    fullUrl = baseUrl;
  }

  useFocusEffect(
    useCallback(() => {
      setIsVisible(true);
      if (onBoardingActive) {
        let incompleteState = onBoardingState.filter(
          (item) => !item.completed
        );
        if (incompleteState.length > 0) {
          router.push({
            pathname: '/OnBoarding',
            params: { incompleteState: JSON.stringify(incompleteState[0]) },
          });
        }
      }
    }, [onBoardingActive, onBoardingState, router])
  );

  // RESET ONBOARDING BUTTON FADEOUT ANFANG
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const fadeOut = () => {
    Animated.timing(position, {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  useEffect(() => {
    if (!isVisible) fadeOut();
  }, [isVisible]);
  // RESET ONBOARDING BUTTON FADEOUT ENDE

  // GESTURE NAVIGATION BACK HANDLING ANFANG
  // useEffect(() => {
  //   const backAction = () => {
  //     if (canGoBack && webViewRef.current) {
  //       webViewRef.current.goBack();
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   };
  //   const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction);

  //   return () => {
  //     backHandler.remove();
  //   };
  // }, [canGoBack]);
  // GESTURE NAVIGATION BACK HANDLING ENDE

  return (
    <>
      <WebView
        //ref={webViewRef}
        style={{ flex: 1, width: Dimensions.get('window').width, height: Dimensions.get('window').height }}
        source={{ uri: fullUrl }}
        webviewDebuggingEnabled={true}
        allowsFullscreenVideo={true}
        allowsInlineMediaPlayback={true}
        allowsBackForwardNavigationGestures={true}
        pullToRefreshEnabled={true}
        mediaPlaybackRequiresUserAction={false}
        sharedCookiesEnabled={true}
        thirdPartyCookiesEnabled={true}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        startInLoadingState={true}
        onNavigationStateChange={handleNavigationEvent}
      />
      {isVisible && (
        <Animated.View
          style={[styles.buttonContainer, { opacity: position.interpolate({ inputRange: [0, 1], outputRange: [1, 0] }) }]}
        >
          <Button title="Reset onBoarding" onPress={resetOnBoarding} />
        </Animated.View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    position: 'absolute',
    bottom: 20,
    left: '3%',
  },
});
